import { Divider, Grid, Paper, Tab, Tabs } from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import { useParams, Outlet, Navigate, useLocation, Link } from 'react-router-dom';
import MainContentHeader from 'src/shared/components/atoms/mainContentHeader';
import GridWrapper from 'src/shared/components/organisms/gridWrapper';
import { RoutesEnum } from 'src/shared/models/enums/routes.enum';
import { getWebFormByName } from 'src/shared/services/webFormService';
import ConsoleHelper from 'src/shared/functions/consoleHelper';
import { useIsMounted } from 'src/shared/hooks/useIsMounted';
import { useTranslation } from 'react-i18next';
import { WebForm } from '../models/webForm';

export const WebFormsDetailWrapper = () => {
  const params = useParams();
  const location = useLocation();
  const isMounted = useIsMounted();
  const { t } = useTranslation(['settings', 'webforms']);
  const [webForm, setWebForm] = useState<WebForm>();

  const fetchData = useCallback(async () => {
    if (!params.name) return;
    try {
      const result = await getWebFormByName(params.name);
      if (isMounted()) setWebForm(result.data);
    } catch (e) {
      ConsoleHelper.log(e);
    }
  }, [params.name, isMounted]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const basePath = `${RoutesEnum.WebFormSettings}/${params.name}`;
  const formPath = `${basePath}/form`;
  const settingsPath = `${basePath}/settings`;
  const embedPath = `${basePath}/embed`;

  // Redirect till form om man står på bas-URL:en
  const isExactBase = !location.pathname.endsWith('/settings') && !location.pathname.endsWith('/form') && !location.pathname.endsWith('/embed');
  if (isExactBase) {
    return <Navigate to={formPath} replace />;
  }

  const tabRoutes = [formPath, settingsPath, embedPath];
  const currentTab = tabRoutes.find((r) => location.pathname.startsWith(r)) ?? formPath;

  return (
    <GridWrapper>
      <Grid item xs={12}>
        <MainContentHeader title={webForm?.formDescription ?? ''} subtitle={webForm?.formName} />
      </Grid>
      <Grid item xs={12}>
        <Paper>
          <Tabs value={currentTab}>
            <Tab label={t('settings:memberRegistry.tabForms')} value={formPath} component={Link} to={formPath} />
            <Tab label={t('webforms:settings')} value={settingsPath} component={Link} to={settingsPath} />
            <Tab label={t('webforms:embededCode')} value={embedPath} component={Link} to={embedPath} />
          </Tabs>
          <Divider />
          <Outlet context={{ webForm, fetchData }} />
        </Paper>
      </Grid>
    </GridWrapper>
  );
};
